export default {
      id: "tapered_baguet-usage",
      viewBox: "0 0 21 30",
      url: __webpack_public_path__ + "icons.svg#tapered_baguet",
      toString: function () {
        return this.url;
      }
    }